// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"c3b87233","290":"c7c55509","716":"32b8f2f3"}[chunkId] + ".chunk.js";
};